const maxDigits = 290
const maxPrimes = 300
const commentsId = "1"

export {maxDigits, maxPrimes, commentsId}